import { TemplateRegistry } from './registry';
import { baseProfile } from './base/profile';
import { template2Profile } from './template-2/profile';

export const templateRegistry = new TemplateRegistry([baseProfile, template2Profile]);

export * from './types';
export * from './registry';

// Add new template profiles here as: templateRegistry.register(myProfile)
